// Redux action types
export const SET = 'one-state-add-info/set';
export const REINIT = 'one-state-add-info/reinit';
